import React from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';
import { colors } from '../../styles/constants';

interface SummaryCardProps {
  title: string;
  value: number;
  icon?: React.ReactNode;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ title, value, icon }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: colors.background.card,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'medium', mb: 1 }}>
            {title}
          </Typography>
          <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', color: colors.secondary.darkSolid }}>
            {value}
          </Typography>
        </Box>
        {icon && (
          <Box sx={{ color: colors.secondary.darkSolid }}>
            {icon}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

interface SummaryCardsProps {
  totalGuests: number;
  welcomePartyAttendees: number;
  weddingAttendees: number;
  needingTransportation: number;
  pendingRsvps?: number;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({
  totalGuests,
  welcomePartyAttendees,
  weddingAttendees,
  needingTransportation,
  pendingRsvps
}) => {
  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      <Grid item xs={12} sm={6} md={pendingRsvps !== undefined ? 2 : 3}>
        <SummaryCard
          title="Total Guests"
          value={totalGuests}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={pendingRsvps !== undefined ? 2 : 3}>
        <SummaryCard
          title="Welcome Party"
          value={welcomePartyAttendees}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={pendingRsvps !== undefined ? 2 : 3}>
        <SummaryCard
          title="Wedding"
          value={weddingAttendees}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={pendingRsvps !== undefined ? 2 : 3}>
        <SummaryCard
          title="Need Transportation"
          value={needingTransportation}
        />
      </Grid>
      {pendingRsvps !== undefined && (
        <Grid item xs={12} sm={6} md={4}>
          <SummaryCard
            title="Pending RSVPs"
            value={pendingRsvps}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SummaryCards;
